import React from "react"
import { graphql, Link } from "gatsby"
import SEO from "../../components/seo"
import Layout from "../../components/layout"
import Hero from "../../components/hero"
import PostSidebar from "../../components/postSidebar"
import SidebarList from "../../components/sidebarList"
import PageBuilder from "../../components/pageBuilder"
import CTA from "../../components/cta"
import { findFirstSectionVideo } from "../../helpers/findFirstSectionVideo"

export const query = graphql`
  query($slug: String) {
    sanityCaseStudy(slug: { current: { eq: $slug } }) {
      newDesign
      title
      publishDate(formatString: "Do MMMM, YYYY")
      _rawLogo(resolveReferences: { maxDepth: 2 })
      _rawBody(resolveReferences: { maxDepth: 10 })
      _rawInfo
      _rawStats
      datePublished: _createdAt
      dateModified: _updatedAt
      theme
      ctaText
      largerCtaText
      _rawCtaButton(resolveReferences: { maxDepth: 10 })
      seo {
        metaTitle
        canonical
        description
        noIndex
        openGraphImage {
          asset {
            url
          }
        }
      }
    }
    sanityCaseStudiesListing {
      caseStudiesListingSettings {
        breadcrumbTitle
      }
    }
  }
`

const BlogTemplate = ({ data }) => {
  const post = data.sanityCaseStudy
  const logo = post._rawLogo
  const embedUrl = findFirstSectionVideo(post?._rawBody)
  const video = embedUrl && { embedUrl }
  const breadcrumbTitle =
    data.sanityCaseStudiesListing.caseStudiesListingSettings.breadcrumbTitle

  const oldDesign = (
    <div className="grid" data-theme={post.theme ? "brandGamma" : "primary"}>
      <div className="gridItem large-3">
        <PostSidebar logo={logo}>
          {post._rawInfo && <SidebarList {...post._rawInfo} />}
          {post._rawStats && post._rawStats.tableRow > 0 && (
            <SidebarList {...post._rawStats} alt />
          )}
        </PostSidebar>
      </div>
      <div className="gridItem large-9">
        <PageBuilder blocks={post._rawBody} />
      </div>
    </div>
  )

  const newDesign = (
    <>
      <PageBuilder newDesign={post.newDesign} blocks={post._rawBody} />
      {(post.ctaText != null || !post._rawCtaButton) && (
        <CTA
          ctaHeader={post.ctaText}
          largerCtaHeader={!!post.largerCtaText}
          ctaButton={post._rawCtaButton}
          theme="primary"
        />
      )}
    </>
  )

  const renderBody = () => {
    if (post.newDesign) return newDesign
    return oldDesign
  }

  return (
    <Layout>
      <SEO
        title={post.title}
        dateModified={post.dateModified}
        datePublished={post.datePublished}
        video={video}
        {...post.seo}
      />
      <Hero
        title={post.title}
        logo={logo}
        isGrcTheme={post.theme}
        newDesign={post.newDesign}
      >
        <p>
          <Link to="/">Home</Link>{" "}
          <Link to="/case-studies/">{breadcrumbTitle}</Link>
        </p>
      </Hero>
      {renderBody()}
    </Layout>
  )
}

export default BlogTemplate
